import {apiService} from '@/services/api'
import axios from "axios";

const ENDPOINTS = {
  IMG_ARENA_CONFIGURATION: '/img-arena-stream/config',
  PAIRED_EVENTS: '/img-arena-stream/paired-imgarena-events',
  INFRONT_PAIRED_EVENTS: '/img-arena-stream/paired-infront-events',
  STATS_PERFORM_PAIRED_EVENTS: '/img-arena-stream/paired-stats-perform-events',
}

class ImgArenaService {
  constructor() {
    this.imgArenaClient = axios.create({});
  }

  async getImgArenaStreamData(sportId) {
    return this.imgArenaClient.get(`${apiService.additionalUrls.imgArenaApi}/api/events/backoffice?ids=${sportId}`)
  }

  async getImgArenaConfig() {
    return apiService.get(ENDPOINTS.IMG_ARENA_CONFIGURATION);
  }

  async updateImgArenaConfig(data) {
    return apiService.post(ENDPOINTS.IMG_ARENA_CONFIGURATION, data);
  }

  async getInfrontStreamData(sportId) {
    return this.imgArenaClient.get(`${apiService.additionalUrls.imgArenaApi}/api/events/infront-backoffice?ids=${sportId}`)
  }

  async getStatsPerformStreamData(sportId) {
    return this.imgArenaClient.get(`${apiService.additionalUrls.imgArenaApi}/api/events/stats-perform-backoffice?ids=${sportId}`)
  }

  async getPairedEvents() {
    return apiService.get(ENDPOINTS.PAIRED_EVENTS);
  }

  async getInfrontPairedEvents() {
    return apiService.get(ENDPOINTS.INFRONT_PAIRED_EVENTS);
  }

  async getStatsPerformPairedEvents() {
    return apiService.get(ENDPOINTS.STATS_PERFORM_PAIRED_EVENTS);
  }

  async updatePairedEvents(data) {
    return apiService.post(ENDPOINTS.PAIRED_EVENTS, data);
  }

  async updateInfrontPairedEvents(data) {
    return apiService.post(ENDPOINTS.INFRONT_PAIRED_EVENTS, data);
  }

  async updateStatsPerformPairedEvents(data) {
    return apiService.post(ENDPOINTS.STATS_PERFORM_PAIRED_EVENTS, data);
  }
}

export const imgArenaService = new ImgArenaService()
